export default __webpack_public_path__ + "static/media/sportsbra-medium-right-toosmall.e7401862.jpg";